module.exports = __webpack_public_path__ + "img/enviva-logo.b51d9bb8.jpg";